import * as React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useStyles } from './Loader.styles';

type LoaderType = 'linear' | 'circular';
type LoaderProps = {
  type?: LoaderType;
  size?: number;
};
const Loader: React.FC<LoaderProps> = ({ type, size = 10 }) => {
  const styles = useStyles();
  switch (type) {
    case 'linear':
      return <LinearProgress />;
    case 'circular':
      return <CircularProgress size={size} />;
    default:
      return <LinearProgress className={styles.global} />;
  }
};

export default Loader;
